import {inject, Injectable} from "@angular/core";
import {LocalStorageService} from "./local-storage.service";


@Injectable({
    providedIn: 'root'
})
export class InactiveModeService {
    private readonly storageService = inject(LocalStorageService)
    private readonly inactiveModeProperty: string = 'inactive-mode';

    private readonly _inactiveModeSignal = this.storageService.signal<boolean>(this.inactiveModeProperty, false);

    public get inactiveMode(): boolean {
        return this._inactiveModeSignal();
    }

    public set inactiveMode(expertMode: boolean) {
        this._inactiveModeSignal.set(expertMode);
    }
}
